import { Inject, Injectable } from '@angular/core';
import { TrackJSConfig } from '../exception-tracking/trackjs.interface';

@Injectable({
  providedIn: 'root'
})
export class TrackJsConfigService {
  private _trackJsConfig: TrackJSConfig[] = [];

  constructor(@Inject('trackjs-config') trackJsConfig: TrackJSConfig[]) {
    this._trackJsConfig = trackJsConfig;
  }

  getTrackJsConfig() {
    return this._trackJsConfig;
  }
}
